export const TIRET = ' - ';
export const POINT_VIRGULE = ";"
export const RETOUR_LIGNE = '\n'